module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Fail Transaction request")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin",
    attrs: {
      "id": "content-wrapper"
    }
  }, [_vm._l((_vm.fields()), function(field, idx) {
    return _c('div', {
      key: idx,
      staticClass: "row top-margin"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', [_c('label', [_vm._v(_vm._s(field.text))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('div', [_c('p', {
      staticClass: "text-right"
    }, [_vm._v("\n                    " + _vm._s(_vm.getValue(field.accessor)) + "\n                  ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin",
    attrs: {
      "id": "comment-section"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.transaction.comment,
      "limit": 255,
      "id": "comment",
      "required": true,
      "placeholder": ""
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  }), _vm._v(" "), (_vm.hasCommentChanged) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("You must enter or append a comment.")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin",
    attrs: {
      "id": "button-section"
    }
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableCancel
    },
    on: {
      "click": _vm.handleCancelRequest
    }
  }, [_vm._v("\n                  Cancel request\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableApprove
    },
    on: {
      "click": _vm.approveFailTransaction
    }
  }, [_vm._v("\n                  Approve request\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmit
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("\n                  Submit request\n                ")])])])], 2)])])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3003dfee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FailTransaction.vue
// module id = 2133
// module chunks = 1